"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["width", "height"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var XIcon = function XIcon(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 100 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 100 : _ref$height,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 14.328l-4.195 4.194a1.657 1.657 0 01-2.327 0 1.657 1.657 0 010-2.327L9.672 12 5.478 7.805a1.657 1.657 0 010-2.327 1.657 1.657 0 012.327 0L12 9.672l4.195-4.194a1.657 1.657 0 012.327 0 1.657 1.657 0 010 2.327L14.328 12l4.194 4.195a1.657 1.657 0 010 2.327 1.657 1.657 0 01-2.327 0L12 14.328z",
    fill: "#3E3D3F"
  }));
};
var _default = XIcon;
exports["default"] = _default;